
<div class="container-fluid" *ngIf="_Meeting.formHideShow==0">
    <div id="form-wrap">
        <h2 class="heading_all">MEETING</h2>
        <br>
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4"></div>
            <div class="col-md-4 ">

                <table>
                    <thead>
                        <tr>
                            <td>
                                <button type="button" class="btn-sm btn-info" (click)="addNew()"><i class="fas fa-plus"
                                        aria-hidden="true"></i></button>
                            </td>
                            <td style="width:60%;"><input type="text" class="form-control-search" name="search"
                                    [(ngModel)]="term"></td>
                            <td><button class="btn-info"><i class="fas fa-search" aria-hidden="true"></i></button></td>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
        <table>
            <thead>
                <tr>
                    <th>#</th>
                    <th class="hidden-xs" style="width:205px;">
                        <div class="AtjIsPoint" (click)="sort('MeetingNo')">
                            <span *ngIf="!_Meeting.isFiltering">Meeting No</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_Meeting.orderByColName!='MeetingNo' "></i>
                                <div *ngIf="_Meeting.orderByColName=='Code'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_Meeting.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_Meeting.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_Meeting.isFiltering">
                            <input type="text" #txtmeetingNoFilter="ngModel" [(ngModel)]="_Meeting.MeetingNoFilter"
                                placeholder="Meeting No">
                        </div>
                    </th>
                    <th class="hidden-xs">
                        <div class="AtjIsPoint" (click)="sort('Topic')">
                            <span *ngIf="!_Meeting.isFiltering">Topic</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_Meeting.orderByColName!='Topic' "></i>
                                <div *ngIf="_Meeting.orderByColName=='Employee'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_Meeting.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_Meeting.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_Meeting.isFiltering">
                            <input type="text" #txtTopicFilter="ngModel"
                                [(ngModel)]="_Meeting.TopicFilter" placeholder="Topic">
                        </div>
                    </th>
                    <th class="hidden-xs">
                        <div class="AtjIsPoint" (click)="sort('ScheduledOn')">
                            <span *ngIf="!_Meeting.isFiltering">Scheduled On</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_Meeting.orderByColName!='ScheduledOn' "></i>
                                <div *ngIf="_Meeting.orderByColName=='Employee'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_Meeting.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_Meeting.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_Meeting.isFiltering">
                            <input type="text" #txtScheduledOn="ngModel"
                                [(ngModel)]="_Meeting.ScheduledOnFilter" placeholder="Scheduled On">
                        </div>
                    </th>                 
                    <th class="hidden-xs">
                        <div class="AtjIsPoint" (click)="sort('Regarding')">
                            <span *ngIf="!_Meeting.isFiltering">Regarding</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_Meeting.orderByColName!='Regarding' "></i>
                                <div *ngIf="_Meeting.orderByColName=='Employee'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_Meeting.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_Meeting.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_Meeting.isFiltering">
                            <input type="text" #txtRegardingFilter="ngModel"
                                [(ngModel)]="_Meeting.RegardingFilter" placeholder="File Name">
                        </div>
                    </th>
                    <th style="width: 135px;"><em></em> Settings
                        <a class="AtjIsPoint AtjfloatRight" (click)="toggleFilter()">
                            <i *ngIf="!_Meeting.isFiltering" class="fas fa-filter"></i>
                            <i *ngIf="_Meeting.isFiltering" class="fas fa-times"></i>
                        </a>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let obj of _Meeting.allMeeting | orderBy : 'Code' | gridOperations  :_Meeting.pageIndex: 
                     {MeetingNo:_Meeting.MeetingNoFilter,Topic:_Meeting.TopicFilter,
                      ScheduledOn:_Meeting.ScheduledOnFilter,Regarding:_Meeting.RegardingFilter}:
                    {Column:_Meeting.orderByColName,Dir:_Meeting.orderByDir} ; let i = index"
                    class="ng-scope">
                    <td>{{i+1+((NoOfItems*_Meeting.pageIndex)-NoOfItems)}}</td>
                    <td style="width:205px;">{{obj.MeetingNo}}</td>
                    <td title="{{obj.Employee}}">{{obj.Topic}}</td>
                    <td title="{{obj.Module}}">{{obj.ScheduledOn}}</td>
                    <td title="{{obj.FileName}}">{{obj.Regarding}}</td>
                    <td style="width: 135px;">
                        <button type="button" class="btn-success" (click)="OnEdit(obj);">
                            <i class="fas fa-pen-square" aria-hidden="true"></i></button>
                        <button type="button" class="btn-danger" (click)="onDelete(obj.ID)"><i
                                class="fas fa-trash" aria-hidden="true"></i></button>
                    </td>
                </tr><!-- end ngRepeat: item in items -->
                <tr>
                    <td colspan="4"
                        *ngIf="(_Meeting.allMeeting?.length<=0 )  || _CommonService.filterdItemCount<1">
                        No Records To Display.</td>
                </tr>
            </tbody>
            <tfoot>
                <td colspan="4" *ngIf="_CommonService.totalPageCount>1">
                    <app-grid-pagination (pageIndexValue)="_Meeting.pageIndex=$event"></app-grid-pagination>
                </td>
            </tfoot>
        </table>
        <div class="margintop"></div>
    </div>
</div>
<app-delete-confirm *ngIf="deletePopUp" [title]="'MEETING'" (ConfirmEvent)="dialogResult($event)"></app-delete-confirm>